(ns iris.tags.common)


(defn equal-tags? [v1 v2]
  (= (map :tag v1)
     (map :tag v2)))

(defn move-up-tags [tags]
  (loop [v tags
         i 0]
    (if (< i (count v))
      (let [current-map (get v i)]
        (if (:selected current-map)
                                      ;; move up (if not at the start)
          (let [new-index (max 0 (dec i))]
                                        ;; Swap the selected element with the new index
            (recur (assoc v i (get v new-index) new-index (get v i)) (inc i)))
                                      ;; No selected, just move to next element
          (recur v (inc i))))
      v)))

(defn move-down-tags [tags]
  (loop [v tags
         i (dec (count v))]
    (if (>= i 0)
      (let [current-map (get v i)]
        (if (:selected current-map)
                                      ;; move down (if not at the end)
          (let [new-index (min (dec (count v)) (inc i))]
                                        ;; Swap the selected element with the new index
            (recur (assoc v i (get v new-index) new-index (get v i)) (dec i)))
                                      ;; No selected, just move to next element
          (recur v (dec i))))
      v)))

(defn move-to-end-tags [tags]
  (let [selected-tags (filter :selected tags)
        unselected-tags (filter #(not (:selected %)) tags)]
    (vec (concat unselected-tags selected-tags))))


(defn move-to-start-tags [tags]
  (let [selected-tags (filter :selected tags)
        unselected-tags (filter #(not (:selected %)) tags)]
    (vec (concat selected-tags unselected-tags))))

(defn deselect-all-tags [tags]
  (println "deselect" (mapv #(assoc-in % [:selected] false) tags))
  (mapv #(assoc-in % [:selected] false) tags))